import './Theme/plugins/fancybox/jquery.fancybox.css';
import './Theme/css/css.css';
import './Theme/css/font-awesome-4.7.0/css/font-awesome.min.css';
import './Theme/css/animate.css';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import Header from './Header';
import Menu from './CommonMenu';
import VideoPageApi from './VideoPageApi';
import HomePageApi from './HomePageApi';
import { API_URL, FILE_URL, LINK_YOUTUBE_IMAGE } from './Constants';

// import 'slick-carousel/slick/slick-theme.css'; 
import $ from 'jquery';
window.jQuery = $;
require('textillate');
require('letteringjs');
require('slick-carousel');


function VideoPage() {
  const [searchParams] = useSearchParams();
  const postId = searchParams.get('id');
  const [dataChiTiet, setDataChiTiet] = useState({});
  const [activeTab, setActiveTab] = useState('MoiNhat');
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [thongKe, setThongKe] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: {
        effect: 'fadeIn',
        delayScale: 3,
        shuffle: false,
      },
      out: {
        effect: 'fadeOut',
        delayScale: 1.5,
        delay: 100,
        sync: false,
        shuffle: false,
        reverse: false,
      }
    });

    $("#sky-bg").fadeIn(2e3);

    $(".slideHomeFade").slick({
      arrows: !1,
      lazyLoad: "ondemand",
      dots: !1,
      infinite: !0,
      speed: 2e3,
      fade: !0,
      slide: "div",
      autoplay: !0,
      autoplaySpeed: 2e3,
      cssEase: "linear"
    });

    $(".slideKinhSachUpdate").slick({
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: !0,
      speed: 3e3,
      dots: !1,
      autoplaySpeed: 5e3,

      // arrows: !1,
    });
    VideoPageApi.getChitietVideo(postId).then((data) => {
      if (data[0].value && data[0].value.includes("youtube.com")) {
        const videoId = data[0].value.split('v=')[1]?.split('&')[0];
        data[0].value = videoId

        const dateStr = data[0].Date_Create;
        const date = new Date(dateStr);
        const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
        data[0].Date_Create = formattedDate;
      }
      setDataChiTiet(data[0]); // Update state with the resolved data
    })

    handleTabClick('MoiNhat');

    HomePageApi.getDataThongKe().then((data) => {
      setThongKe(data); // Update state with the resolved data
    })

    return () => {
      // Destroy Slick carousel to avoid memory leaks
      $('.slideHomeFade').slick('unslick');
      $('.slideKinhSachUpdate').slick('unslick');
    };

  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1); // Reset to first page on tab change
    callApi(tab, 1);
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    callApi(activeTab, page);
  };

  const callApi = (tab, currentPage) => {
    switch (tab) {
      case 'MoiNhat':
        VideoPageApi.getVideosMoiNhat(currentPage).then((data) => {
          data.data.forEach((item) => {
            const videoId = getVideoID(item.value)
            item.imageUrl = LINK_YOUTUBE_IMAGE.replace('{videoId}', videoId);
          });
          setTotalPages(data.totalPages)
          setData(data.data); // Update state with the resolved data
        })
        break;
      case 'XemNhieu':
        VideoPageApi.getVideosXemNhieu(currentPage).then((data) => {
          data.data.forEach((item) => {
            const videoId = getVideoID(item.value)
            item.imageUrl = LINK_YOUTUBE_IMAGE.replace('{videoId}', videoId);
          });
          setTotalPages(data.totalPages)
          setData(data.data); // Update state with the resolved data
        })
        break;
      case 'TaiNhieu':
        VideoPageApi.getVideosTaiNhieu(currentPage).then((data) => {
          data.data.forEach((item) => {
            const videoId = getVideoID(item.value)
            item.imageUrl = LINK_YOUTUBE_IMAGE.replace('{videoId}', videoId);
          });
          setTotalPages(data.totalPages)
          setData(data.data); // Update state with the resolved data
        })
        break;
      default:
        break;
    }
  }

  const getVideoID = (url) => {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/|(?:v|e(?:mbed|d)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const downloadVideo = async (videoId) => {
    try {
      setLoading(true); // Show spinner
      VideoPageApi.downloadVideo(videoId).then((response) => {
          // Get the response as a Blob (binary data)
          const videoBlob = response;
          console.log("videoBlob", videoBlob)

          // Create a URL for the Blob
          const videoURL = window.URL.createObjectURL(videoBlob);

          // Create an anchor element for downloading the file
          const a = document.createElement('a');
          a.href = videoURL;
          a.download = 'video.mp4';  // Set the file name
          document.body.appendChild(a);
          a.click();  // Trigger the download
          document.body.removeChild(a);  // Clean up
      });
    } catch (error) {
      console.error("Error downloading video:", error);
      // setMessage("Failed to download video. Please try again.");
    } finally {
      setLoading(false); // Hide spinner
    }
  };

  useEffect(() => {
    // Initial API call on mount
    callApi(activeTab, currentPage);
  }, [activeTab, currentPage]);

  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>Pháp Ấn Sơn | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />
      <meta name="keywords" content="linh quy pháp ấn; linh quy phap an; Nikaya;  linhquyphapan; linhquy" />
      <meta name="description" content=" Pháp Ấn Sơn" />

      {/* <link href='https://fonts.googleapis.com/css?family=Roboto+Condensed|Open+Sans:400,700,400italic' rel='stylesheet' type='text/css'>
          <link href="/Theme/plugins/fancybox/jquery.fancybox.css" rel="stylesheet" />
          <link href="/Theme/css/css.css" rel="stylesheet"/>
          <link rel="stylesheet" href="/Theme/css/font-awesome-4.7.0/css/font-awesome.min.css">
          <link href="/Theme/css/animate.css" rel="stylesheet" />
          
          <script src="/Theme/js/jquery-1.11.2.min.js"></script> */}
      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
          <li className="tlt" />
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />
      <section>

        <div>
            {loading && <div className="loading-spinner">Loading...</div>}
            {/* <button onClick={() => downloadVideo("videoId")}>Download Video</button> */}
            {/* Add spinner styling */}
            <style jsx>{`
              .loading-spinner {
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 1.5rem;
                color: #555;
              }
            `}</style>
        </div>

        <div className="container contentContainer">
          <div className="row">
            <div className="col-md-9  col-sm-9 col-xs-12">
              <Menu value={"video"} />
              {/* content video */}
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <link href="/Theme/plugins/mediaelement4/mediaelementplayer.min.css" rel="stylesheet" />

                  {/* <div className="videoContainer">
                    <video height={500} alt="Tinh Hoa NIKAYA - Thiền Quán Ngàn Hoa" title="Tinh Hoa NIKAYA - Thiền Quán Ngàn Hoa" autoPlay preload="none" id="mainplayler">
                      <source type="video/youtube" src="https://www.youtube.com/watch?v=MgvA7ANFK4k" />
                    </video>
                  </div> */}

                  <div className="videoContainer">
                    <iframe
                      title={dataChiTiet?.title}
                      width="100%"
                      height={300}
                      src={`https://www.youtube.com/embed/${dataChiTiet?.value}`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>

                  <div className="chiTietVideoAudio">
                    <div className="row">
                      <div className="col-md-6">
                        <h1>
                          {dataChiTiet?.title}
                        </h1>
                        <p />
                        <p>Ngày đăng : {dataChiTiet?.Date_Create}</p>
                      </div>
                      <div className="col-md-6">
                        <div className="sharethis">
                          <span className="viewed-count"><strong>Lượt xem: </strong>{dataChiTiet?.ViewedCount}</span>
                          <span className="st_googleplus_large" displaytext="Google +" />
                          <span className="st_facebook_large" displaytext="Facebook" />
                        </div>
                        <div className="downloadvideo">
                          <a className="btn" href="javascript:;" onclick="turnofflight()">
                            <i className="fa fa-power-off" /> Tắt đèn
                          </a>
                          <a className="btnAddFav btn" href="javascript:;" data-id={dataChiTiet?.id} data-type="audio" data-title={dataChiTiet?.title}>
                            <i className="fa fa-plus" /> Thêm vào
                          </a>
                          <a className="btn fancybox fancybox.ajax btn-downloadfile" onClick={() => downloadVideo(dataChiTiet?.id)}>
                            <i className="fa fa-download" /> Tải video về
                          </a>
                        </div>
                      </div>
                      <div className="col-md-12">
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
                <div className="col-md-12 col-sm-12 col-xs-12 tabVideoAudio">
                  <article className="tab-container">
                    <nav className="tab-nav nav nav-tabs">
                      <li
                        style={{ backgroundColor: activeTab === 'MoiNhat' ? 'rgb(255,219,74)' : 'transparent' }}
                        onClick={() => handleTabClick('MoiNhat')}
                      >
                        <a className="btnTab" title="Mới nhất">
                          <i className="fa fa-upload" /> MỚI NHẤT
                        </a>
                      </li>
                      <li
                        style={{ backgroundColor: activeTab === 'XemNhieu' ? 'rgb(255,219,74)' : 'transparent' }}
                        onClick={() => handleTabClick('XemNhieu')}
                      >
                        <a className="btnTab" title="Xem nhiều">
                          <i className="fa fa-eye" /> XEM NHIỀU
                        </a>
                      </li>
                      <li
                        style={{ backgroundColor: activeTab === 'TaiNhieu' ? 'rgb(255,219,74)' : 'transparent' }}
                        onClick={() => handleTabClick('TaiNhieu')}
                      >
                        <a className="btnTab" title="Tải nhiều">
                          <i className="fa fa-download" /> TẢI NHIỀU
                        </a>
                      </li>
                    </nav>
                    <div className="tab-pane-container">
                      <section id="MoiNhat" className="homeListVideoUpdate video">
                        <div className="row paddingVideoList">

                          {data?.map((item, index) => (
                            <div className="col-md-3 col-sm-6 col-xs-12 itemHomeListVideo itemListVideoTab">
                              <div className="containerOverlay">
                                <img className="thumbHover" alt={item?.title} title={item?.title} src={item?.imageUrl} />
                                <div className="overlay">
                                  <a className="videoHover1" href={`/video/${item?.Slug_Full}?id=${item?.id}`}> <i className="fa fa-eye "> </i> Xem </a>
                                  <a className=" videoHover2 iconDonwload2 btnAddFav" data-id={item?.id} data-type="video" data-title={item?.title}><i className="fa fa-plus-square" /> Thêm</a>
                                  <a className="iconDonwload2 videoHover3 fancybox fancybox.ajax btn-downloadfile" href="javascript:;" data-fancybox-href="/Widget/YoutubeDownload/30119?videourl=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DceuQQjakPOw">
                                    <i className="fa fa-download" /> Tải
                                  </a>
                                </div>
                              </div>
                              <div className="listVideoTitle2">
                                <a className="Title" href={`/video/${item?.Slug_Full}?id=${item?.id}`}>
                                  {item?.title}
                                </a>
                                <p>
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="row">
                          <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="pagination-container">
                              <ul className="pagination">
                                {currentPage > 1 && (
                                  <li className="PagedList-skipToLast">
                                    <a onClick={() => handlePageClick(1)}>««</a>
                                  </li>
                                )}
                                {currentPage > 1 && (
                                  <li className="PagedList-skipToNext">
                                    <a onClick={() => handlePageClick(currentPage - 1)} rel="prev">«</a>
                                  </li>
                                )}

                                {/* Display only 10 pagination items */}
                                {[...Array(totalPages)].map((_, index) => {
                                  const page = index + 1;
                                  const startPage = Math.max(1, currentPage - 3); // Start 5 pages before current page
                                  const endPage = Math.min(totalPages, currentPage + 8); // End 5 pages after current page

                                  if (page >= startPage && page <= endPage) {
                                    return (
                                      <li key={page} className={currentPage === page ? 'active' : ''}>
                                        <a onClick={() => handlePageClick(page)}>{page}</a>
                                      </li>
                                    );
                                  }
                                  return null;
                                })}

                                {currentPage < totalPages && (
                                  <li className="PagedList-skipToNext">
                                    <a onClick={() => handlePageClick(currentPage + 1)} rel="next">»</a>
                                  </li>
                                )}
                                {currentPage < totalPages && (
                                  <li className="PagedList-skipToLast">
                                    <a onClick={() => handlePageClick(totalPages)}>»»</a>
                                  </li>
                                )}
                              </ul>

                            </div>
                          </div>
                        </div>
                        <div className="loadingContainer loading" id="loadingTab">
                          <img className="gifLoading" src="/Theme/img/loading.GIF" />
                        </div>
                      </section>
                    </div>
                  </article>
                </div>
              </div>
              {/* //content video */}
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 homeThongBao none-padding-left">
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12  none-padding-left  boxNews">
                  <div className="containerRightBox">
                    <h5 className="titleRightHome">DANH MỤC VIDEO</h5>
                    <ul className="nav nav-pills nav-stacked listDanhMuc">
                      <li>
                        <a href="/video/nghi-thuc-nikaya">
                          <i className="fa fa-angle-right" /> Nghi Thức Nikaya
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/nghi-thuc-nikaya/2024-7">
                              2024
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/phap-dam">
                          <i className="fa fa-angle-right" /> Pháp Đàm
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/phap-dam/2024-8">
                              2024
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/thien-biet-on">
                          <i className="fa fa-angle-right" /> Thiền Biết Ơn
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/thien-biet-on/2024-9">
                              2024
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/nikaya-khat-thuc">
                          <i className="fa fa-angle-right" /> Nikaya Khất Thực
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/nikaya-khat-thuc/2024-10">
                              2024
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/nikaya-trinh-phap">
                          <i className="fa fa-angle-right" /> Nikaya Trình Pháp
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/nikaya-trinh-phap/2024-11">
                              2024
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/2-thien-quan">
                          <i className="fa fa-angle-right" /> Thiền Quán
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                        </ul>
                      </li>
                      <li>
                        <a href="/video/meu-dizer-chefe-vao">
                          <i className="fa fa-angle-right" /> Bài giảng cho Tăng Ni
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2007">
                              2007
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2008-2">
                              2008
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2009">
                              2009
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2010">
                              2010
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2011-2">
                              2011
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2012-2">
                              2012
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2013-2">
                              2013
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2014-2">
                              2014
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2015-2">
                              2015
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2016-2">
                              2016
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2017">
                              2017
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2018-2">
                              2018
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2019-2">
                              2019
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/-54">
                              2020
                            </a>
                          </li>
                          <li>
                            <a href="/video/meu-dizer-chefe-vao/2021">
                              2021
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/si-ja-roubado-osculou-empatar">
                          <i className="fa fa-angle-right" /> Bài Giảng Theo Bộ
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2-2006">
                              2006
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/umas-alli-alta-viam-ler-por">
                              2007
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2008-3">
                              2008
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2009-2">
                              2009
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2010-2">
                              2010
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2011-3">
                              2011
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2012-3">
                              2012
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2013-3">
                              2013
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2014-3">
                              2014
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2015-3">
                              2015
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2016-3">
                              2016
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2017-3">
                              2017
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2018-3">
                              2018
                            </a>
                          </li>
                          <li>
                            <a href="/video/si-ja-roubado-osculou-empatar/2019-5">
                              2019
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/bai-giang-pho-thong-2">
                          <i className="fa fa-angle-right" /> Bài Giảng Phổ Thông
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2024-6">
                              2024
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2005-2">
                              2005
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2006-3">
                              2006
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2007-2">
                              2007
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2008-4">
                              2008
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2009-3">
                              2009
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2010-3">
                              2010
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2011-4">
                              2011
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2012-4">
                              2012
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2013-4">
                              2013
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2014-4">
                              2014
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2015-4">
                              2015
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2016-4">
                              2016
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2017-2">
                              2017
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2018-4">
                              2018
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2019-6">
                              2019
                            </a>
                          </li>
                          <li>
                            <a href="/video/bai-giang-pho-thong-2/2020-2">
                              2020
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/soi-sang-2">
                          <i className="fa fa-angle-right" /> Soi Sáng
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/soi-sang-2/2008-8">
                              2008
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2009-8">
                              2009
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2010-8">
                              2010
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2011-9">
                              2011
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2012-9">
                              2012
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2013-9">
                              2013
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2014-9">
                              2014
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2015-9">
                              2015
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2016-5">
                              2016
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2017-4">
                              2017
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2018-5">
                              2018
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2019-4">
                              2019
                            </a>
                          </li>
                          <li>
                            <a href="/video/soi-sang-2/2020-3">
                              2020
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="/video/faceis-perdia-tinhas">
                          <i className="fa fa-angle-right" /> Bài giảng tại Am Pháp Ấn
                        </a>
                        <i className="dropbutton"><span className="fa fa-chevron-down" /></i>
                        <ul className="hide">
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2022">
                              2022
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/ando-na-tu-acto-tolo-ja">
                              2008
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/pe-ou-ella-es-fila-como">
                              2009
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/na-um-novos-abrir-es-ardor-menos">
                              2010
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2011">
                              2011
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2012">
                              2012
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2013">
                              2013
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2014">
                              2014
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2015">
                              2015
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2016">
                              2016
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2-2017-9">
                              2017
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2018">
                              2018
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2019">
                              2019
                            </a>
                          </li>
                          <li>
                            <a href="/video/faceis-perdia-tinhas/2020">
                              2020
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row" data-wow-delay="0.4s">
                <div className="col-md-12 col-sm-12 col-xs-12   none-padding-left">
                  <a className="playlistWidget" href="/danh-sach-playlist/1">
                    <img src={require("./Theme/img/show_playlist.png")} />
                  </a>
                </div>
              </div>
              <div className="homestats">
                <h5 className="tittleHome">THỐNG KÊ</h5>
                <ul>
                  <li className="text-center">
                    <strong>Chi tiết thống kê</strong>
                  </li>
                  <li>
                    <i className="fa fa-globe" />
                    Đang truy cập: 1
                  </li>
                  <li>
                    <i className="fa fa-globe" />
                    Lượt truy cập : {thongKe[0] && thongKe[0].TotalCounter}
                  </li>
                  <li>
                    <i className="fa fa-headphones" />
                    Tổng lượng nghe : {thongKe[0] && thongKe[0].TotalViews}
                  </li>
                  <li>
                    <i className="fa fa-download" />
                    Tổng Download : {thongKe[0] && thongKe[0].TotalDownload}
                  </li>
                  <li className="text-center">
                    <strong>Thống kê hôm nay</strong>
                  </li>
                  <li>
                    <i className="fa fa-users" />
                    Lượt truy cập hôm nay: {thongKe[0] && thongKe[0].countUserVisitToday}
                  </li>
                  <li>
                    <i className="fa fa-cloud-download" />
                    Download trong ngày : {thongKe[0] && thongKe[0].countDownloadToday}
                  </li>
                  <li>
                    <i className="fa fa-user" />
                    <a href="/Dang-nhap">Đăng nhập</a>
                  </li>
                </ul>
              </div>
              <div className="homestats">
                <h5 className="tittleHome">LIÊN KẾT</h5>
                <ul>
                  <li>
                    <i className="fa fa-facebook" />
                    <a href="https://www.facebook.com/LINH-QUY-PH%C3%81P-%E1%BA%A4N-260666811038785/" target="_blank">Facebook</a>
                  </li>
                  <li>
                    <i className="fa fa-youtube" />
                    <a href="https://www.youtube.com/channel/UCnI54Nrr9AddC4pDdpIjyCg" target="_blank">YouTube</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/*// content */}
      </section>
      <footer>
        <div className="container">
          {/* <div className="_Slide3DContainer wow fadeInUp" data-wow-delay="0.4s">
            <ul className="carousel ">
              <li className="item active">
                <a href="/kinh-sach/cua-vao-bat-tu" className="itemSlide3d" tipcontent="CỬA VÀO BẤT TỬ"><img src={require("./Upload/images/z2345923129108_b9a2cd08e07aba3cab7e274c4c1896db.jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/nghi-thuc-tu-hoc-nikaya" className="itemSlide3d"><img src={require("./Upload/images/Nghi Thức Tu Học NIKAYA(1).jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/phap-hanh-nikaya-can-ban" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hy-ngot-ngao" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hien-van-an" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
            </ul>
          </div> */}
        </div>
      </footer>
      <section className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-1">
              <img className="img-responsive" src={require("./Theme/img/linhqquylogo-small.jpg")} />
            </div>
            <div className="col-md-5">
              Copyright © 2011 - 2024<br />Linhquyphapan.vn, All right reserved <br />Chủ nhiệm: Thượng Toạ Thích Minh Thành
            </div>
            <div className="col-md-6">
              Thôn 4 - Xã Lộc Thành - Huyện Bảo Lâm - Tỉnh Lâm Đồng <br />SĐT: 0963 232 651 , 0766 522 181<br />Email: linhquyphapan@yahoo.com <br /> www.linhquyphapan.vn
            </div>
          </div>
        </div>
      </section>
      <p id="back-top" style={{ display: 'none' }}>
        <a href="#top"><span /></a>
      </p>
      <div id="fb-root" />
    </div>
  );
}

export default VideoPage;
